let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fZUun")).then(() => parcelRequire('hreQA'));